/**
 * Export data to CSV file
 * @param {Array} headers - Array of header names
 * @param {Array} data - Array of data objects
 * @param {String} filename - Name of the output file (without extension)
 */
export function exportToCSV(headers, data, filename) {
    // Convert headers to CSV format
    const csvHeaders = headers.map(header => `"${header}"`).join(',');

    // Convert data to CSV format
    const csvContent = data.map(item => {
        return Object.values(item).map(field => {
            // Escape double quotes and wrap in quotes
            return `"${String(field || '').replace(/"/g, '""')}"`;
        }).join(',');
    }).join('\n');

    // Combine headers and data
    const csv = `${csvHeaders}\n${csvContent}`;

    // Create blob and download
    const blob = new Blob(['\ufeff', csv], {
        type: 'text/csv;charset=utf-8;'
    });

    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    // Add timestamp to filename if not already included
    const timestamp = new Date().toISOString().slice(0, 10);
    const fullFilename = filename.includes(timestamp) ?
        `${filename}.csv` :
        `${filename}_${timestamp}.csv`;

    link.setAttribute('href', url);
    link.setAttribute('download', fullFilename);
    link.style.visibility = 'hidden';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}